import ExportService from "../services/ExportService";
import FileSaver, { saveAs } from 'file-saver'

export default class ExportManager {

    constructor() {
        this.exportService = new ExportService();
        this.formatAndSend = this.formatAndSend.bind(this);
    }

    download(result) {
        var element = document.createElement('a');
        element.setAttribute('href', this.exportService.host + "/api/export/download/" + result);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    saveDocument(fileWrapper) {
        FileSaver.saveAs(fileWrapper.reportBytes, fileWrapper.documentName, { type: fileWrapper.contentType });
    }



    //{name:"Unknown", dataSets:[{name:"Unknown Sheet",data:[]}]}; 
    formatAndSend(exportType, dataWrapper, allMaps, timeFilter, callback) {
        const errmsg = "There was an error while downloading the file.";
        var exportData = {
            ClientAccountId: "",
            MapToReportKPIs: true,
            Properties: { DocumentName: dataWrapper.name }
        };

        var data = {};
        if (exportType == "csv" || exportType == "excel") {
            exportData.Properties.SheetProperty = {};
            dataWrapper.dataSets.forEach(ds => {
                var kpiIdentifiers = [];
                var dataRows = [];
                
                exportData.Properties.SheetProperty[ds.name] = {
                    ColumnProperties: {}
                };

                let showGrandTotals = false;
                let fromDate = timeFilter.fromDate;
                let toDate = timeFilter.toDate;
                console.log(fromDate) 
                console.log(toDate) 
                


                if (dataWrapper.ShowGrandTotal !== undefined && dataWrapper.ShowGrandTotal !== null) {
                    showGrandTotals = dataWrapper.ShowGrandTotal;
                }

                exportData.Properties.SheetProperty[ds.name].ShowGrandTotal = showGrandTotals;
                exportData.Properties.StartDate = fromDate;
                exportData.Properties.EndDate= toDate;

                ds.data.forEach(d => {
                    let dataRow = null;
                    let newDataRow = true;
                    if (d.key != null && d.key != undefined) {
                        for (let i = 0; i < dataRows.length; i++) {
                            let keyDataRow = dataRows[i];
                            if (keyDataRow.key == d.key) {
                                newDataRow = false;
                                dataRow = keyDataRow;
                            }
                        }

                        if (newDataRow) {
                            dataRow = {};
                            dataRow.key = d.key;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.key = {
                                IsUnautherized: true
                            }
                        }
                    }
                    else {
                        dataRow = {};
                    }

                    if (newDataRow) {

                        console.log('New Row Added');

                        dataRow.storeId = d.columns.storeId;
                        exportData.Properties.SheetProperty[ds.name].ColumnProperties.storeId = {
                            ColumnNameOverride: "Store Id",
                            Hidden: true
                        }

                        if (ds.dsName == "blastsbd") {
                            dataRow["Date"] = d.key;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.Date = {
                                ColumnFormat: 999 //string 
                            }
                        }

                        if (ds.dsName == "blastp") {
                            dataRow.employeeName = toFriendlyName(ds.dsName, "employeeUniqueName", d.columns.employeeUniqueName);
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.employeeName = {
                                ColumnNameOverride: "Employee Name",
                                ColumnFormat: 999 //string 
                            }
                        }
                        else {
                            dataRow.storeName = d.columns.storeName;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.storeName = {
                                ColumnNameOverride: "Store Name",
                                ColumnFormat: 999 //string 
                            }
                        }

                        if (d.columns.storeName == undefined) {
                            if (d.columns.storeId != undefined && d.columns.storeId != null && d.columns.storeId != "") {
                                dataRow.storeName = allMaps.storeMap[d.columns.storeId];
                                exportData.Properties.SheetProperty[ds.name].ColumnProperties.storeName = {
                                    ColumnNameOverride: "Store Name"
                                }

                            }
                        }

                        if (d.columns.customerId != undefined && d.columns.customerId != null && d.columns.customerId != "") {
                            dataRow.customerId = d.columns.customerId;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.customerId = {
                                ColumnNameOverride: "Customer Id",
                                Hidden: true
                            }
                        }

                        dataRow.city = d.columns.city;
                        exportData.Properties.SheetProperty[ds.name].ColumnProperties.city = {
                            ColumnNameOverride: "City",
                            ColumnFormat: 999 //string 
                        }

                        if (d.columns.customerName != undefined && d.columns.customerName != null && d.columns.customerName != "") {
                            dataRow.customerName = d.columns.customerName;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.customerName = {
                                ColumnNameOverride: "Customer Name"
                            }

                        }

                        if (d.columns.productName != undefined && d.columns.productName != null && d.columns.productName != "") {
                            dataRow.productName = d.columns.productName;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.productName = {
                                ColumnNameOverride: "Product Name"
                            }

                        }


                        if (d.columns.treatmentName != undefined && d.columns.treatmentName != null && d.columns.treatmentName != "") {
                            dataRow.treatmentName = d.columns.treatmentName;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.treatmentName = {
                                ColumnNameOverride: "Service Name"
                            }
                        }

                        if (d.columns.brandId != undefined && d.columns.brandId != null && d.columns.brandId != "") {
                            dataRow.brandName = allMaps.brandMap[d.columns.brandId];
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.brandName = {
                                ColumnNameOverride: "Brand Name"
                            }

                        }


                        if (d.columns.categoryName != undefined && d.columns.categoryName != null && d.columns.categoryName != "") {
                            dataRow.categoryName = d.columns.categoryName;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.categoryName = {
                                ColumnNameOverride: "Category Name"
                            }
                        }

                        if (d.columns.subCategoryName != undefined && d.columns.subCategoryName != null && d.columns.subCategoryName != "") {
                            dataRow.subCategoryName = d.columns.subCategoryName;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.subCategoryName = {
                                ColumnNameOverride: "Sub Category Name"
                            }

                        }

                        if (d.columns.dateOfBirth != undefined) {
                            dataRow.dateOfBirth = d.columns.dateOfBirth;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.dateOfBirth = {
                                ColumnNameOverride: "Date Of Birth",
                            }
                        }


                        if (d.columns.gender != undefined && d.columns.gender != null && d.columns.gender != "") {
                            dataRow.gender = d.columns.gender;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.gender = {
                                ColumnNameOverride: "Gender"
                            }
                        }

                        if (d.columns.occupation != undefined && d.columns.occupation != null && d.columns.occupation != "") {
                            dataRow.occupation = d.columns.occupation;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.occupation = {
                                ColumnNameOverride: "Occupation"
                            }
                        }

                        if (d.columns.firstVisit != undefined) {
                            dataRow.firstVisit = d.columns.firstVisit;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.firstVisit = {
                                ColumnNameOverride: "First Visit Date"
                            }
                        }

                        if (d.columns.lastVisit != undefined) {
                            dataRow.lastVisit = d.columns.lastVisit;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.lastVisit = {
                                ColumnNameOverride: "Last Visit Date"
                            }
                        }

                        if (d.columns.lastUpdate != undefined && d.columns.lastUpdate != null && d.columns.lastUpdate != "") {
                            dataRow.lastUpdate = d.columns.lastUpdate;
                            exportData.Properties.SheetProperty[ds.name].ColumnProperties.lastUpdate = {
                                ColumnNameOverride: "Last Update"
                            }
                        }
                    }

                    dataRow[d.kpiIdentifier] = d.cyCustom;
                    var columnFormat = 1002;
                    if (d.columns.prec == "1") {
                        columnFormat = 1006;
                    }
                    else if (d.columns.type == "INT") {
                        columnFormat = 1000;
                    }
                    else if (d.columns.type == "MNY") {
                        columnFormat = 1005;
                    }
                    else if (d.columns.type == "DC1") {
                        columnFormat = 1001;
                    }

                    exportData.Properties.SheetProperty[ds.name].ColumnProperties[d.kpiIdentifier] = {
                        ColumnNameOverride: d.columns.name,
                        ColumnFormat: columnFormat,
                        CanTotal: (columnFormat > 999 && columnFormat < 1007),
                        IsAverage: (d.columns.type == "PCT" || d.columns.isAvg == "True")
                    }
                    if (newDataRow) {
                        dataRows.push(dataRow);
                    }
                });
                data[ds.name] = dataRows;
            });
            exportData.data = data;
        }

        if (exportType == "csv") {
            this.exportService.csv(exportData, (result) => {
                //this.saveDocument(result);
                this.download(result);
            }, (error) => {
                alert(errmsg);
                callback(error);
            });
        }
        else if (exportType == "excel") {
            this.exportService.excel(exportData, (result) => {
                //this.saveDocument(result);
                this.download(result);
            }, (error) => {
                alert(errmsg);
                callback(error);
            });
        }
        else if (exportType == "pdf") {
            var imageList = document.getCanvasAsImages(dataWrapper.cardIds);
            var html = "<html><body class='override-body'><head><link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/ZeeMD.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/ZeeMD.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/ZeeZorMain.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/ZeeZorDesktop.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/ZeeZorMedia.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/ZeeZorWorkspace.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/PDFPrintWorkspace.css'>" +
                "<link rel='stylesheet' type='text/css' href='" + window.__globalConfig.baseUrl + "/App/css/PDFPrintVisual.css'>" +
                "</head> <div class='workspace-center-outer workspace-center-outer-override' >" + dataWrapper.dataSets[0].data + "</div> </body></html>";
            exportData.data = html;
            exportData.Properties.PdfPageSize = "A1";
            exportData.Properties.WebPageHeight = document.getCardViewHeight();

            this.exportService.pdf(exportData, (result) => {
                //this.saveDocument(result);
                this.download(result);
            }, (error) => {
                alert(errmsg);
                callback(error);
            });
        }
    }
}